"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CUSTOM_THEME_NOT_FUND = exports.PROJECT_THEME_ALREADY_EXISTS = exports.CONSTANT_NOT_FUND = exports.ENVIRONMENT_NOT_FOUND = exports.JS_URL_TAG_ALREADY_EXISTS = exports.CSS_URL_TAG_ALREADY_EXISTS = exports.FILE_NOT_FOUND = exports.PROJECT_CSS_URL_ALREADY_EXISTS = exports.PROJECT_CSS_ALREADY_EXISTS = exports.PROJECT_ENVIRONMENT_TYPE_ALREADY_EXISTS = exports.PROJECT_ENVIRONMENT_ALREADY_EXISTS = exports.PROJECT_CONSTANT_ALREADY_EXISTS = exports.PROJECT_NOT_FOUND = void 0;
exports.PROJECT_NOT_FOUND = "Project not found.";
exports.PROJECT_CONSTANT_ALREADY_EXISTS = "A constant with this name already exists.";
exports.PROJECT_ENVIRONMENT_ALREADY_EXISTS = "A environment with this name already exists.";
exports.PROJECT_ENVIRONMENT_TYPE_ALREADY_EXISTS = "A environment with this type already exists.";
exports.PROJECT_CSS_ALREADY_EXISTS = "A CSS Class with this name already exists.";
exports.PROJECT_CSS_URL_ALREADY_EXISTS = "A CSS URL already exists.";
exports.FILE_NOT_FOUND = "File not found";
exports.CSS_URL_TAG_ALREADY_EXISTS = "A CSS URL/Link Tag already exists.";
exports.JS_URL_TAG_ALREADY_EXISTS = "A JavaScript URL/Script Tag already exists.";
exports.ENVIRONMENT_NOT_FOUND = "Environment not found.";
exports.CONSTANT_NOT_FUND = "Constant not found.";
exports.PROJECT_THEME_ALREADY_EXISTS = "Project already has a theme.";
exports.CUSTOM_THEME_NOT_FUND = "Custom Theme not Found";